import { Case } from 'services';
export const CaseLocationUnsafeMock: Case[] = [
  {
    id: 'CLU-001',
    tenant: {
      tenantId: '488296E409C5C8B8',
      displayName: 'name',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      titleId: 'BC4A',
      displayName: 'tname'
    },
    subject: {
      subjectId: '47.6429479,-122.1362855',
      subjectType: 'LocationUnsafe',
      subjectValue: '47.6429479,-122.1362855',
      subjectLabels: ['Tappable'],
      subjectOwners: [
        {
          userId: '734538',
          username: 'Ninja',
          userType: 'Mixer'
        }
      ],
      subjectHashes: undefined,
      subjectMetadata: undefined
    },
    caseEvidence: {
      'Channel URL': 'https://www.mixer.com/Ninja',
      'Channel ID': '12345',
      'Channel Title': '2v2 Tournament Mode!',
      'Channel Partnered': 'True',
      'Channel Featured': 'False',
      'Channel Audience': '18+',
      'Mixer ID': '67890',
      'Mixer Name': 'Ninja',
      Game: 'Call of Duty: Modern Warfare',
      'Current Viewers': '464',
      'Total Viewers': '38780',
      'Total Followers': '8720',
      'Stream Duration': '00:09:20'
    },
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '',
    status: '',
    caseContext: {
      ReportID: 314000141
    },
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CLU-002',
    tenant: {
      tenantId: '488296E409C5C8B8',
      displayName: 'name',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      titleId: 'BC4A',
      displayName: 'tname'
    },
    subject: {
      subjectId: '47.6429479,-122.1362855',
      subjectType: 'LocationUnsafe',
      subjectValue: undefined,
      subjectLabels: ['Tappable'],
      subjectOwners: [
        {
          userId: '734538',
          username: 'Ninja',
          userType: 'Mixer'
        }
      ],
      subjectHashes: undefined,
      subjectMetadata: undefined
    },
    caseEvidence: {
      'Channel URL': 'https://www.mixer.com/Ninja',
      'Channel ID': '12345',
      'Channel Title': '2v2 Tournament Mode!',
      'Channel Partnered': 'True',
      'Channel Featured': 'False',
      'Channel Audience': '18+',
      'Mixer ID': '67890',
      'Mixer Name': 'Ninja',
      Game: 'Call of Duty: Modern Warfare',
      'Current Viewers': '464',
      'Total Viewers': '38780',
      'Total Followers': '8720',
      'Stream Duration': '00:09:20'
    },
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '',
    status: '',
    caseContext: {
      ReportID: 314000141
    },
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CLU-003',
    tenant: {
      tenantId: '488296E409C5C8B8',
      displayName: 'name',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      titleId: 'BC4A',
      displayName: 'tname'
    },
    subject: {
      subjectId: '47.6429479,-122.1362855',
      subjectType: 'LocationUnsafe',
      subjectValue: undefined,
      subjectLabels: ['Tappable'],
      subjectOwners: [
        {
          userId: '734538',
          username: 'Ninja',
          userType: 'Mixer'
        }
      ],
      subjectHashes: undefined,
      subjectMetadata: undefined
    },
    caseEvidence: {
      'Channel URL': 'https://www.mixer.com/Ninja',
      'Channel ID': '12345',
      'Channel Title': '2v2 Tournament Mode!',
      'Channel Partnered': 'True',
      'Channel Featured': 'False',
      'Channel Audience': '18+',
      'Mixer ID': '67890',
      'Mixer Name': 'Ninja',
      Game: 'Call of Duty: Modern Warfare',
      'Current Viewers': '464',
      'Total Viewers': '38780',
      'Total Followers': '8720',
      'Stream Duration': '00:09:20'
    },
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '',
    status: '',
    caseContext: {
      ReportID: 314000141
    },
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  }
];
